// extracted by mini-css-extract-plugin
export default {"wrapper":"cLtj2","banner":"b29SF"};